
/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachineGroups/ActionsCreators/VirtualMachineGroupCreateActionCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { IEnvironmentService } from "Environments/Client/EnvironmentService";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVirtualMachinesProviderData, PageKey } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Utilities"; 
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";
import { getErrorMessage, IResourceCreatedResponse } from "Environments/EnvironmentsCommon/Utils";
import { VirtualMachineGroupCreateParameters, EnvironmentResource } from "DistributedTask/Client/Contracts/TaskAgent";
import { VirtualMachineGroupCreateActions } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Actions/VirtualMachineGroupCreateActions";

export class VirtualMachineGroupCreateActionCreator extends ActionCreatorBase {

    public static getKey(): string {
        return "virtualmachines-resource-create-actions-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);

        this._actions = ActionsHubManager.CreateActionsHub<VirtualMachineGroupCreateActions>(VirtualMachineGroupCreateActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions> (MessagesActions, instanceId);
    }

    public createResource(pageContext: IVssPageContext, resourceData: IVirtualMachinesProviderData, environmentId: number, resourceCreatedResponse: IResourceCreatedResponse) {
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");

        environmentService.addVirtualMachinesResource({
            name: resourceData.name
        } as VirtualMachineGroupCreateParameters, environmentId)
            .then((resource: EnvironmentResource) => {
                this._messageActions.clearMessage.invoke(PageKey.AddVirtualMachinesResourceView);
                this._actions.addVirtualMachinesResource.invoke(resource);
            }, (error: any) => {
                resourceCreatedResponse.onError(getErrorMessage(error));
                this._messageActions.addMessage.invoke({ key: PageKey.AddVirtualMachinesResourceView, value: getErrorMessage(error) });
            });
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<VirtualMachineGroupCreateActions>(VirtualMachineGroupCreateActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: VirtualMachineGroupCreateActions;
    private _messageActions: MessagesActions;
}
